import {View, StyleSheet} from 'react-native';
import React from 'react';
import {SkillzButton} from '@skillz-rn/atoms';
import {WITHDRAW_BUTTON_TEXT} from './BankWithdrawalConstants';

type WithdrawButtonProps = {
  onPress?: () => void;
  disabled?: boolean;
};

const WithdrawButton = ({onPress, disabled}: WithdrawButtonProps) => {
  return (
    <View style={styles.container}>
      <SkillzButton
        text={WITHDRAW_BUTTON_TEXT}
        size={'L'}
        branding='Game'
        type='Tertiary'
        containerStyle={styles.ctaButtonContainer}
        onPress={onPress}
        disabled={disabled}
        textProps={{allowFontScaling: false}}
      />
    </View>
  );
};

export default WithdrawButton;

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    height: 60,
    alignItems: 'center',
    marginBottom: 5,
    backgroundColor: '#FAFAFA',
  },
  ctaButtonContainer: {
    width: '95%',
    alignSelf: 'center',
  },
});
